<template>
  <div class="search">
    <Card>
      <Row v-show="openSearch" @keydown.enter.native="handleSearch">
        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
          <FormItem label="租户名称" prop="name">
            <Input
              type="text"
              v-model="searchForm.name"
              placeholder="请输入租户名称"
              clearable
              style="width: 200px"
            />
          </FormItem>
          <FormItem style="margin-left: -35px" class="br">
            <Button @click="handleSearch" type="primary" icon="ios-search"
              >搜索</Button
            >
            <Button @click="handleReset">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Row class="operation">
        <Button @click="add" type="primary" icon="md-add">添加</Button>
        <!-- <Button @click="delAll" icon="md-trash">批量删除</Button> -->
        <Button @click="handleRefresh" icon="md-refresh">刷新</Button>
        <!-- <Button type="dashed" @click="openSearch = !openSearch">{{
          openSearch ? "关闭搜索" : "开启搜索"
        }}</Button>
        <Button type="dashed" @click="openTip = !openTip">{{
          openTip ? "关闭提示" : "开启提示"
        }}</Button> -->
      </Row>
      <!-- <Alert show-icon v-show="openTip">
        已选择
        <span class="select-count">{{ selectList.length }}</span> 项
        <a class="select-clear" @click="clearSelectAll">清空</a>
      </Alert> -->
      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="data"
        ref="table"
        sortable="custom"
        @on-sort-change="changeSort"
        @on-selection-change="changeSelect"
      ></Table>
      <Row type="flex" justify="end" class="page">
        <Page
          :current="searchForm.pageNumber"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        ></Page>
      </Row>

      <addEdit
        :data="form"
        :type="showType"
        v-model="showDrawer"
        @on-submit="getDataList"
      />
    </Card>
    <Modal v-model="downLicenseModal" width="360">
      <p slot="header" style="text-align: center">
        <Icon type="md-cloud-download" />
        <span>证书下载</span>
      </p>
      <div style="text-align: center" width="360">
        <Input
          v-model="licenseVal"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          placeholder="Enter something..."
        ></Input>
      </div>
      <div slot="footer">
        <a
          :href="'data:application/octet-stream;base64,' + licenseVal"
          target="_blank"
          rel="noopener noreferrer"
          download="keystore.p12"
        >
          <Button
            type="success"
            size="large"
            long
            @on-click="downLicenseModal = false"
            >下载密钥文件</Button
          >
        </a>
      </div>
    </Modal>
  </div>
</template>

<script>
// 根据你的实际请求api.js位置路径修改
import {
  getTenantList,
  deleteTenant,
  downloadTenantLicense,
  enableTenant,
} from "@/api/index";
import { getStrByApproveType } from "@/api/convert";
// 根据你的实际添加编辑组件位置路径修改
import addEdit from "./addEdit.vue";
import { shortcuts } from "@/libs/shortcuts";
export default {
  name: "tenant",
  components: {
    addEdit,
  },
  data() {
    return {
      licenseVal: "",
      downLicenseModal: false,
      openSearch: true, // 显示搜索
      openTip: true, // 显示提示
      showType: "0", // 添加或编辑标识
      showDrawer: false, // 显示添加编辑抽屉
      loading: true, // 表单加载状态
      searchForm: {
        // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "createTime", // 默认排序字段
        order: "desc", // 默认排序方式
      },
      selectList: [], // 多选数据
      form: {},
      columns: [
        // // 表头
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        // },
        {
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "租户Id",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "租户名称",
          key: "name",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "租户描述",
          key: "des",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "机构hubUrl",
          key: "hubUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "机构apiUrl",
          key: "apiUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "机构webUrl",
          key: "webUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "过期时间",
          key: "expireTime",
          minWidth: 120,
          sortable: false,
        },
        // {
        //   title: "状态",
        //   key: "approveStatus",
        //   minWidth: 120,
        //   sortable: false,
        //   render: (h, params) => {
        //     let re = getStrByApproveType(params.row.approveStatus);
        //     let color = "#c5c8ce";
        //     return h("div", [
        //       h(
        //         "div",
        //         {
        //           props: {
        //             color: color,
        //           },
        //         },
        //         re
        //       ),
        //     ]);
        //   },
        // },
        {
          title: "生成授权",
          key: "id",
          minWidth: 125,
          render: (h, params) => {            
            return h("div", [
              h("Icon", {
                props: {
                  type: "md-download",
                  color: "#c5c8ce",
                },
                style: {
                  margin: "0 5px 0 0",
                },
              }),
              h(
                "a",
                {
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.downLicense(params.row);
                    },
                  },
                },
                "生成授权"
              ),
            ]);            
          },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 150,
          render: (h, params) => {
            let statusTag = params.row.status == 1 ? "禁用" : "启用";
            if (params.row.approveStatus == 2 || params.row.approveStatus == 3) {
              return h("div", [
                h(
                  "a",
                  {
                    on: {
                      click: () => {
                        this.edit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h("Divider", {
                  props: {
                    type: "vertical",
                  },
                }),
                h(
                  "a",
                  {
                    on: {
                      click: () => {
                        this.changeStatus(params.row);
                      },
                    },
                  },
                  statusTag
                ),
              ]);
            }
          },
        },
      ],
      data: [], // 表单数据
      pageNumber: 1, // 当前页数
      pageSize: 10, // 页面大小
      total: 0, // 表单数据总数
    };
  },
  methods: {
    downLicense(row) {
      this.downLicenseModal = true;

      downloadTenantLicense(row).then((res) => {
        if (res.success) {
          this.licenseVal = res.result;
        }
      });
    },
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    handleRefresh(){
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
    },
    getDataList() {
      this.loading = true;
      getTenantList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
          if (this.data.length == 0 && this.searchForm.pageNumber > 1) {
            this.searchForm.pageNumber -= 1;
            this.getDataList();
          }
        }
      });
    },
    add() {
      this.showType = "2";
      this.showDrawer = true;
    },
    edit(v) {
      // 转换null为""
      for (let attr in v) {
        if (v[attr] == null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.showType = "1";
      this.showDrawer = true;
    },
    changeStatus(v) {
      let changeStatus = v.status == 1 ? 0 : 1;
      this.$Modal.confirm({
        title: "确认操作",
        // 记得确认修改此处
        content: "您确认要禁用/启用该条数据?",
        loading: true,
        onOk: () => {
          v.status = changeStatus;
          enableTenant(v).then((res) => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
        },
      });
    },
    delAll() {
      if (this.selectList.length <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectList.length + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function (e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          deleteTenant({ ids: ids }).then((res) => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
        },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
@import "@/styles/table-common.less";
// .search {
//     .operation {
//         margin-bottom: 2vh;
//     }
//     .select-count {
//         font-weight: 600;
//         color: #40a9ff;
//     }
//     .select-clear {
//         margin-left: 10px;
//     }
//     .page {
//         margin-top: 2vh;
//     }
//     .drop-down {
//         margin-left: 5px;
//     }
// }
</style>